import axios from 'axios'

const state = {
    userCampaigns: [],
    gotUserCampaigns: false,
}

const getters = {
    getUserCampaigns: state => state.userCampaigns,
    userCampaignsOk: state => state.gotUserCampaigns
}

const actions = {
    fetchUserCampaigns: ({commit}) => {
        return new Promise((resolve, reject) => {
          axios({method:'get', url:'campaigns/'})
          .then(resp => {
            let campaigns = resp.data            
            if (campaigns.length) {
              campaigns = campaigns.sort((a,b) => a.name.localeCompare(b.name))              
            }
            commit('FETCH_USER_CAMPAIGNS', campaigns)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        })
    },
}

const mutations = {
    FETCH_USER_CAMPAIGNS: (state, campaigns) => {
        state.userCampaigns = campaigns
        state.gotUserCampaigns = true
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
  };